import { SearchOptions } from '@algolia/client-search';
import { DeviceType } from '../types';

export enum AlgoliaIndiceName {
  PRODUCTS = 'products',
  PRODUCTS_MOBILE = 'products_mobile',
  PRODUCTS_PRICE_ASC = 'products_price_asc',
  PRODUCTS_PRICE_DESC = 'products_price_desc',
  QUERY_SUGGESTIONS = 'query_suggestions',
  LOCAL_MERCHANTS = 'local_merchants',
  ZIP_CODES = 'zipcodes',
  CATEGORIES = 'categories',
  BRANCH_STORES = 'branch_stores',
  EXCLUDED_PARTNERS = 'excluded_partners',
  FACET_VALUES = 'facet_values',
}

export interface AlgoliaSearchParams {
  deviceType?: DeviceType;
  indiceName?: AlgoliaIndiceName;
  queryParameters: SearchOptions;
}

export const MAX_PARTNERS_TO_ROTATE = 3;
export const DEFAULT_PRODUCT_LIST_HITS_PER_PAGE = 192;
